import axiosInst from "./config/axiosConfig";

const getUserListByGroup = async (body) => axiosInst.post("/beta/usersListByGroup", body);

const createNewUser = async (body) => axiosInst.post("/beta/usersAdd", body);

const deleteUser = async (body) => axiosInst.post("/beta/usersDelete", body);

export { getUserListByGroup, createNewUser, deleteUser };
